import type { ModelViewerElement } from '@google/model-viewer';

function getAvailableAnimations(mv: ModelViewerElement): string[] {
  const animations = (mv as ModelViewerElement & { availableAnimations?: string[] }).availableAnimations || [];
  return animations.filter((name) => Boolean(name && name.trim()));
}

/** Same names in the same order. Used so a fresh array does not force a React render. */
export function animationNamesEqual(left: readonly string[], right: readonly string[]): boolean {
  if (left.length !== right.length) return false;
  for (let index = 0; index < left.length; index += 1) {
    if (left[index] !== right[index]) return false;
  }
  return true;
}

/**
 * Cycle the active GLB animation track on a model-viewer element.
 * @returns The newly selected animation name, or null if none available.
 */
export function cycleModelViewerAnimation(
  mv: ModelViewerElement | null | undefined,
  direction: 1 | -1 = 1
): string | null {
  if (!mv) return null;

  const animations = getAvailableAnimations(mv);
  if (animations.length === 0) return null;

  const current =
    (mv as ModelViewerElement & { animationName?: string }).animationName?.trim() || '';
  const currentIndex = animations.indexOf(current);
  const from = currentIndex >= 0 ? currentIndex : 0;
  const nextIndex = (from + direction + animations.length) % animations.length;
  const nextName = animations[nextIndex];

  try {
    (mv as ModelViewerElement & { animationName: string }).animationName = nextName;
    mv.play();
    return nextName;
  } catch (error) {
    console.error('Error cycling model-viewer animation:', error);
    return null;
  }
}
